// External
import React, { createContext, memo, useContext } from "react";

const LessonPlanningAssistant = createContext(null);

const LessonPlanningAssistantProvider = memo(props => {
  const { children, value } = props;
  return (
    <LessonPlanningAssistant.Provider value={value}>
      {children}
    </LessonPlanningAssistant.Provider>
  );
});

const useLessonPlanningAssistant = () => useContext(LessonPlanningAssistant);

LessonPlanningAssistantProvider.displayName = "LessonPlanningAssistantProvider";

export { LessonPlanningAssistantProvider, useLessonPlanningAssistant };
